// Evita duplicar el listener si el editor recarga secciones
if (!window.__storeSwitcherBound) {
  window.__storeSwitcherBound = true;

  document.addEventListener('click', function(e){
    const btn = e.target.closest('.mnav__store-toggle');
    const drawer = e.target.closest('#NavDrawer');

    if (btn) {
      e.preventDefault(); e.stopPropagation();
      const container = btn.closest('.mnav__store');
      const list = container.querySelector('.mnav__store-list');
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      if (list) { list.hidden = expanded; }
      container.classList.toggle('is-open', !expanded);
      return;
    }

    // Click fuera: cierra si está abierto
    if (drawer && !e.target.closest('.mnav__store')) {
      const open = drawer.querySelector('.mnav__store.is-open');
      if (open) {
        const b = open.querySelector('.mnav__store-toggle');
        const l = open.querySelector('.mnav__store-list');
        if (b) b.setAttribute('aria-expanded','false');
        if (l) l.hidden = true;
        open.classList.remove('is-open');
      }
    }
  });
}
